export default __webpack_public_path__ + "static/media/Strangler's Fauld of Waning Dusk.69050d79.jpg";